import { render, staticRenderFns } from "./WarwickshirePolice.vue?vue&type=template&id=87dceab4&scoped=true"
import script from "./WarwickshirePolice.vue?vue&type=script&lang=js"
export * from "./WarwickshirePolice.vue?vue&type=script&lang=js"
import style0 from "./WarwickshirePolice.vue?vue&type=style&index=0&id=87dceab4&prod&scoped=true&lang=css"
import style1 from "./WarwickshirePolice.vue?vue&type=style&index=1&id=87dceab4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dceab4",
  null
  
)

export default component.exports